module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//9.jpg?0da73ba518332ef2cb4bfbbcece37e66";